import { useState, useMemo } from "react";
import PropTypes from 'prop-types';
import { secondsToTime } from "../../../../shared/utility";
import { saveAs } from "file-saver";
import CustomToast from "../../../UI/customToast";
import { ButtonWithLoader } from "../../../UI/Button/Button";
import { AI_SUMMARY_SUB_TAB } from "../../../../constants/Constants";
import { parseSummaryContent, generateSummaryText } from "./summaryUtils";

const AISummaryActionPanel = ({ localisedValues, searchTranscriptText, setSearchTranscriptText, fileName, modifiedTranscription, activeTab, aiSummary, summaryFileName }) => {
  const [isDownload, setIsDownload] = useState(false)

  const hasSummaryContent = useMemo(() => {
    const parsedContent = parseSummaryContent(aiSummary);
    return parsedContent && Object.keys(parsedContent).length > 0;
  }, [aiSummary]);

  const handleDownloadTranscription = async () => {
    if (isDownload) return
    setIsDownload(true);

    try {
      const files = modifiedTranscription?.map(
        (item) => `${secondsToTime(item.CallDuration)}: ${item.Name || "Participant"}: ${item.Text}\n`)
        .join("\n");

      const blob = new Blob([files], { type: "text/plain;charset=utf-8" });

      await CustomToast.promise(
        new Promise((resolve) => {
          saveAs(blob, `${fileName}`);
          resolve();
        }),
        {
          pending: localisedValues?.downloading,
          success: localisedValues?.successfully_downloaded,
          error: localisedValues?.download_failed,
        }
      );
    } catch (err) {
      console.log("Error in transcription download", err);
    } finally {
      setTimeout(() => {
        setIsDownload(false);
      }, 2000);
    }
  };

  const handleDownloadSummary = async () => {
    if (isDownload) return;
    setIsDownload(true);

    try {
      const parsedContent = parseSummaryContent(aiSummary);
      const summaryText = generateSummaryText(parsedContent);

      const blob = new Blob([summaryText], { type: "text/plain;charset=utf-8" });

      await CustomToast.promise(
        new Promise((resolve) => {
          saveAs(blob, summaryFileName);
          resolve();
        }),
        {
          pending: localisedValues?.downloading,
          success: localisedValues?.successfully_downloaded,
          error: localisedValues?.download_failed,
        }
      );
    } catch (err) {
      console.log("Error in summary download", err);
    } finally {
      setTimeout(() => {
        setIsDownload(false);
      }, 2000);
    }
  };

  return (
    <div className="summary-tab-right">
      {activeTab === AI_SUMMARY_SUB_TAB.TRANSCRIPT && (
        <div className="search-form right-icon sm">
          <div className="form-group-in">
            <span className="for-icon icon-search margin-0"></span>
            <input
              type="text"
              value={searchTranscriptText}
              onChange={(e) => setSearchTranscriptText(e.target.value)}
              className="form-control"
              placeholder={localisedValues?.search}
            />
          </div>
        </div>
      )}

      {(activeTab === AI_SUMMARY_SUB_TAB.TRANSCRIPT || hasSummaryContent) && (
        <div className="summary-tab-nav-button">
          <div className="button">
            <ButtonWithLoader
              className="btn btn-sm2 btn-primary font-weight-500 btn-with-icon"
              name={localisedValues?.download_key}
              disable={isDownload}
              onClick={activeTab === AI_SUMMARY_SUB_TAB.SUMMARY ? handleDownloadSummary : handleDownloadTranscription}
              showLoader={isDownload}
            >
            </ButtonWithLoader>
          </div>
        </div>
      )}
    </div>
  )
}

AISummaryActionPanel.propTypes = {
  localisedValues: PropTypes.object,
  searchTranscriptText: PropTypes.string,
  setSearchTranscriptText: PropTypes.func,
  fileName: PropTypes.string,
  modifiedTranscription: PropTypes.array,
  activeTab: PropTypes.string,
  aiSummary: PropTypes.object,
  summaryFileName: PropTypes.string,
};

export default AISummaryActionPanel
